import { Identifiable, Status } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function isBasic(task: Identifiable<Status>): boolean {
  const basicStatuses = ["pr_done", "pr_in_progress", "pr_todo"];

  return !!basicStatuses.find((basicStatus) => basicStatus === task.label);
}

function createInteractor(repository: Repository): Interactor {
  return (project) =>
    present(
      repository
        .getKanban(project)
        .then((kanban) => ({
          kanban: {
            ...kanban,
            columns: kanban.columns.map((column) => ({
              ...column,
              status: {
                ...column.status,
                basic: isBasic(column.status),
              },
            })),
          },
          project,
        }))
        .catch(() => Promise.reject(project)),
    );
}

export type { Interactor };

export { createInteractor };
